import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SendResetPasswordLink,
	type SendResetPasswordLinkMutation,
	type SendResetPasswordLinkMutationVariables,
} from './sendResetPasswordLink.graphql';

export async function sendResetPasswordLink(
	input: SendResetPasswordLinkMutationVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data } = await fetch<SendResetPasswordLinkMutation, SendResetPasswordLinkMutationVariables>({
		query: SendResetPasswordLink,
		variables: input,
		rejectOnError: true,
	});
	return !!data.sendResetPasswordLink?.success;
}
